import React, { useState, useEffect } from 'react';
import { FaMapMarkerAlt } from 'react-icons/fa';
import inventoryData from '../data/inventory.json';
import { COMPANY_CONFIG } from '../config/company';
import InventoryModal from '../components/InventoryModal';
import './Inventory.css';

const Inventory = () => {
  const [inventory, setInventory] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    setInventory(inventoryData.inventory);
  }, []);

  const openModal = (item) => {
    setSelectedItem(item);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedItem(null);
  };

  const formatTrafficCount = (count) => {
    if (count >= 1000000) {
      return `${(count / 1000000).toFixed(1)}M`;
    } else if (count >= 1000) {
      return `${(count / 1000).toFixed(0)}K`;
    }
    return count.toString();
  };



  return (
    <div className="inventory-page">
      <div className="inventory-hero">
        <div className="container">
          <h1>Our Billboard Inventory</h1>
          <p>Premium advertising locations across {COMPANY_CONFIG.serviceAreas.join(', ')}</p>
          <p className="inventory-hero-note">Free Vinyl and Install included on all 1 year contracts!</p>
        </div>
      </div>

      <div className="container">
        <div className="inventory-grid">
          {inventory.map((item) => (
            <div key={item.signNumber} className="inventory-item" onClick={() => openModal(item)}>
              <div className="item-header">
                <div className="item-image">
                  <img src={item.images[0]} alt={item.name} />
                  {item.overlay && (
                    <div className="image-overlay">
                      <span className="overlay-text">{item.overlay}</span>
                    </div>
                  )}
                </div>
                <div className="item-basic-info">
                  <h3>{item.name}</h3>
                  <p className="sign-number">Sign #{item.signNumber}</p>
                  <div className="location-info">
                    <FaMapMarkerAlt />
                    <span>{item.city}</span>
                  </div>
                  <div className="traffic-info">
                    <strong>{formatTrafficCount(item.weeklyTrafficCount)}</strong> weekly traffic
                  </div>
                </div>

              </div>


            </div>
          ))}
        </div>
      </div>

      {/* Inventory Modal */}
      <InventoryModal
        item={selectedItem}
        isOpen={isModalOpen}
        onClose={closeModal}
      />
    </div>
  );
};

export default Inventory; 